/** The alternate target applies only to the last possible game, never a straight-games clincher. */
export function pointsForGame(
  format: { bestOf: number; pointsPerGame: number; decidingGamePoints?: number | null },
  gameNumber: number,
): number {
  return format.bestOf > 1 && gameNumber === format.bestOf
    ? (format.decidingGamePoints ?? format.pointsPerGame)
    : format.pointsPerGame;
}
